import { buildFilterMapping } from '@/components/AgGrid/helpers/filterHelpers';

const filterMappingByColumnType = [
  {
    string: { filter: 'agTextColumnFilter' },
  },
];

export const filterMapping = buildFilterMapping(filterMappingByColumnType);
